import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonSelectMultiple from "../../../components/forms/CommonSelectMultiple";
import { handleChangeMultipleSelect } from "../../../helpers/handleFormChanges";
import CommonInput from "../../../components/forms/CommonInput";
import PropTypes from "prop-types";

function CnaeModal({
  isOpen,
  setIsOpen,
  valuesHook,
  cnaes,
  itensServico,
  criarRelacionamento,
}) {
  const { values, setValues } = valuesHook;
  const anexos = [
    { nome: "Anexo I", descricao: "Anexo I comércio" },
    { nome: "Anexo II", descricao: "Anexo II indústria" },
    { nome: "Anexo III", descricao: "Anexo III serviços" },
    { nome: "Anexo IV", descricao: "Anexo IV serviços" },
    { nome: "Anexo V", descricao: "Anexo V serviços" },
  ];

  return (
    <CommonModal
      title={"Novo relacionamento"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="lg"
      buttons={
        <CommonButton
          key={`salvar-cnae`}
          onClick={() => {
            criarRelacionamento();
          }}
          color="success"
        >
          Salvar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonSelect
            label="CNAE"
            id="cnae"
            value={values.cnae}
            onChange={(e) => {
              const selectedOption = e.target.options[e.target.selectedIndex];
              const selectedDescricao = selectedOption
                ? selectedOption?.dataset?.descricao
                : null;
              const selectedFatorR = selectedOption
                ? selectedOption?.dataset?.fatorr
                : null;

              setValues({
                ...values,
                [e.target.name]: e.target.value,
                cnaeDescricao: selectedDescricao,
                fatorR: selectedFatorR,
              });
            }}
            data={
              cnaes &&
              cnaes.map((cnae) => ({
                text: `${cnae.codigo} - ${cnae.descricao}`,
                id: cnae.codigo,
                "data-descricao": cnae.descricao,
                "data-fatorr": cnae.fator_r,
              }))
            }
            placeholder="Selecione um CNAE"
            required
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonSelect
            label="Item de serviço"
            id="itemServico"
            value={values.itemServico}
            onChange={(e) => {
              const selectedOption = e.target.options[e.target.selectedIndex];
              const selectedDescricao = selectedOption
                ? selectedOption?.dataset?.descricao
                : null;

              setValues({
                ...values,
                [e.target.name]: e.target.value,
                itemDescricao: selectedDescricao,
              });
            }}
            data={
              itensServico &&
              itensServico.map((itemServico) => ({
                text: `${itemServico.codigo} - ${itemServico.descricao}`,
                id: itemServico.codigo,
                "data-descricao": itemServico.descricao,
              }))
            }
            placeholder="Selecione um item de serviço"
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInput
            label="Fator R"
            id="fatorR"
            value={values.fatorR}
            onChange={() => {}}
            disabled
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonSelectMultiple
            label="Anexo"
            id="anexo"
            value={values?.anexo
              ?.map((nome) => anexos.find((anexo) => anexo.nome === nome))
              .filter(Boolean)}
            onChange={(e, newValue) => {
              handleChangeMultipleSelect(
                values,
                setValues,
                "anexo",
                newValue,
                "nome"
              );
            }}
            data={anexos}
            optionLabel="descricao"
          />
        </div>
      </div>
    </CommonModal>
  );
}

CnaeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  cnaes: PropTypes.arrayOf(PropTypes.object).isRequired,
  itensServico: PropTypes.arrayOf(PropTypes.object).isRequired,
  criarRelacionamento: PropTypes.func.isRequired,
};

export default CnaeModal;
